"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActiveElement;

function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/getActiveElement.js
 ** module id = 1414
 ** module chunks = 0
 **/